import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DashboardSandbox } from '../../../../core/dashboard/dashboard.sandbox';
import { OrderSandbox } from '../../../../core/order/order.sandbox';
import { PaymentSandbox } from '../../../../core/payment/payment.sandbox';
import { ChartOptions, ChartType } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Label } from 'ng2-charts';
import { CommonSandbox } from '../../../../core/common/common.sandbox';
import { ConfigService } from '../../../../core/services/config.service';
import { CommonService } from '../../../../core/common/common.service';
import { AuthSandbox } from '../../../../core/auth/auth.sandbox';
import { SocialAuthService } from "angularx-social-login";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment-timezone';
import { CustomerService } from '../../../../core/customers/customer.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public todayDate = new Date();
  public duration = 1;
  public orderDuration = 1;
  public userData: any = { permissions: {} };
  public userDetails = JSON.parse(localStorage.getItem('vendorUserDetails'));
  public currencyCode = this.userDetails?.currencyCode;
  public subscriptions = [];
  public showIncomplete = true;
  public showEventMessage = false;
  public eventMessage = '';
  user: any;
  public miniDate: any;
  public minStartDate: any;
  public dateError: string;
  public isRequired = false;
  public fromDate: any;
  public toDate: any;
  public filterByDateType = 0;
  public showCustomDates = false;
  public invoice: any;
  public vendorShops: any = [];
  public totalCount: any = 0;

  constructor(
    private router: Router,
    public dashboardSandbox: DashboardSandbox,
    public paymentSandbox: PaymentSandbox,
    public orderSandbox: OrderSandbox,
    public commonSandbox: CommonSandbox,
    public commonService: CommonService,
    public authSandbox: AuthSandbox,
    public config: ConfigService,
    private authService: SocialAuthService,
    public toaster: ToastrService,
    public customerService: CustomerService,
  ) { }

  // chart options
  public pieChartOptions: ChartOptions = {
    responsive: true,

    elements: {
      arc: {
        borderWidth: 1
      }

    },
    legend: {
      position: 'bottom',
      onClick: function (e) {
        e.stopPropagation();
      },
      labels: {
        boxWidth: 10,

        fontSize: 14,
      }

    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return null;
        }
      },
      labels: [
        {
          render: 'label',
          position: 'outside'
        },
        {
          render: 'value'
        }
      ]
    }
  };

  public barChartOptions: ChartOptions = {

    responsive: true,
    legend: {

      position: 'left',
      onClick: function (e) {
        e.stopPropagation();
      },
      labels: {
        boxWidth: 10,
        fontSize: 16,
      },
    },
    plugins: {
      // datalabels: {
      //   formatter: (value, ctx) => {
      //     const label = ctx.chart.data.labels[ctx.dataIndex];
      //     return null;
      //   }
      // },
      labels: [
        {

          render: 'label',
          position: 'outside'
        },
        {
          render: 'value'
        }
      ],

    }
  };
  public showXAxis: boolean = true;
  public showYAxis: boolean = true;
  public pieChartLabels: Label[] = [];
  public pieChartData: number[] = [];
  public barChartData: number[] = [];
  public barChartLabels: Label[] = [];

  public checkoutBarChartLabels: Label[] = [];
  public checkoutBarChartData: number[] = [];

  public checkoutPieChartColors = [

    {
      backgroundColor: [

        'rgba(86, 198, 210, 1)',
        'rgba(226, 226, 226, 1)',
        'rgba(185, 228, 147, 1)',
        'rgba(205, 221, 63, 1)',
        'rgba(15, 70, 181, 1)',

      ],
      borderWidth: 0
    }
  ];

  public pieChartType: ChartType = 'pie';
  public barChartType: ChartType = 'bar';
  public pieChartLegend = true;
  public barChartLegend = false;
  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors = [
    {
      backgroundColor: [

        'rgba(86, 198, 210, 1)',
        'rgba(205, 221, 63, 1)',
        'rgba(185, 228, 147, 1)',
        'rgba(103, 152, 227, 1)',
        'rgba(109, 200, 152, 1)',
        'rgba(15, 70, 181, 1)',

      ],
      borderWidth: 0
    }
  ];

  public barChartColors = [

    {
      backgroundColor: [
        'rgba(226, 226, 226, 1)',
        'rgba(86, 198, 210, 1)',
        'rgba(185, 228, 147, 1)',
      ],
      borderWidth: 0
    }
  ];

  ngOnInit() {
    this.authService.authState.subscribe(user => {
      this.user = user;
      // console.log(user,'user================');
    });

    this.getDashboardCount();
    this.getOrdersList();
    this.getRecentPaymentList();
    this.getTopSellingProducts();
    this.getOrders();
    this.commonSandbox.doGetProfile();
    this.getEventMessage();
    this.getInvoice();
    this.subscriptions.push(
      this.commonSandbox.getProfile$.subscribe(data => {
        if (data && Object.keys(data).length) {
          console.log("userdata", data);
          this.userData = data;
        }
      })
    );
    this.getVendorShops();
    this.dashboardSandbox.dashboardCount$.subscribe(data => {
      this.barChartData = [];
      this.barChartLabels = [];

      this.checkoutBarChartData = [];
      this.checkoutBarChartLabels = [];
      if (data) {

        this.checkoutBarChartData.push(Number(data.cartAdded));
        this.checkoutBarChartData.push(Number(data.checkingOut || 0));
        this.checkoutBarChartData.push(Number(data.websiteCheckout) + Number(data.marketPlaceCheckout));

        this.checkoutBarChartLabels.push('Active Carts');
        this.checkoutBarChartLabels.push('Checking Out');
        this.checkoutBarChartLabels.push('Purchased');

        this.barChartData.push(Number(data.websiteCheckout));
        this.barChartData.push(Number(data.posCheckout));
        this.barChartData.push(Number(data.marketPlaceCheckout));

        this.barChartLabels.push('Website');
        this.barChartLabels.push('POS');
        this.barChartLabels.push('Market Place');

        this.pieChartColors[0].backgroundColor.push('rgba(86, 198, 210, 1)');
        this.pieChartColors[0].backgroundColor.push('rgba(226, 226, 226, 1)');
        this.pieChartColors[0].backgroundColor.push('rgba(185, 228, 147, 1)');
        this.pieChartColors[0].backgroundColor.push('rgba(185, 228, 147, 1)');
      }
    });
  }
  getInvoice() {
    this.commonService.getInvoice({}).toPromise().then((data: any) => {
      console.log(data);
      if (data && data.data) {
        this.invoice = data.data;
      }
    })
  }

  getEventTime(product) {
    const time = product.expirationTime.split(':');
    const date = product.expirationDate.split('T')[0];
    return moment.tz(date, 'YYYY-MM-DD', product.timezone).set('hours', time[0]).set('minutes', time[1]).local().format('HH:mm:ss');
  }

  getEventDate(product) {
    const time = product.expirationTime.split(':');
    const date = product.expirationDate.split('T')[0];
    return moment.tz(date, 'YYYY-MM-DD', product.timezone).set('hours', time[0]).set('minutes', time[1]).local().format('YYYY-MM-DD');
  }

  getEventMessage() {
    this.authSandbox.subscription$.subscribe((data: any) => {
      if (data && data.todaysEvents) {
        for (let event of data.todaysEvents) {
          let eventDate = this.getEventDate(event);
          let eventTime = this.getEventTime(event);

          let date = moment.tz(eventDate + " " + eventTime, event.timezone).local();

          let now = moment().local();

          if (now.isBefore(date)) {
            this.showEventMessage = true;
            this.eventMessage = `You have an upcoming event at ${date.format('HH:mm')} today`;
          }

        }
      }
    });
  }

  getVendorShops() {
    const params: any = {};
    this.customerService.getVendorShops(params).toPromise().then(response => {
      this.vendorShops = response.data;
      this.totalCount = response.totalCount;
    });
  }
  // get all dashboard counts
  getDashboardCount() {
    const params: any = {};
    params.filterByDateType = this.filterByDateType;

    params.fromDate = this.fromDate;
    params.toDate = this.toDate;

    this.dashboardSandbox.getDashboardCounts(params);
  }

  // get recent orders list
  getOrdersList() {
    const params: any = {};
    params.limit = 4;
    params.offset = 0;
    this.dashboardSandbox.getOrderList(params);
  }
  gotoUsers() {
    this.router.navigate(['/customers/list/' + "dob"]);
    // this.router.navigate('/customer')
  }
  enableShop() {
    const params: any = {};
    params.firstName = this.userData['customerDetail']['firstName'];
    params.email = this.userData['companyEmailId'];
    params.mobileNumber = this.userData['customerDetail']['mobileNumber'];
    params.lastName = this.userData['customerDetail']['lastName'];
    params.designation = this.userData['designation'];
    params.companyName = this.userData['companyName'];
    params.companyAddress1 = this.userData['companyAddress1'];
    params.companyAddress2 = this.userData['companyAddress2']
    params.companyCity = this.userData['companyCity'];
    params.companyState = this.userData['companyState'];
    params.stateId = this.userData['stateId'];
    params.companyCountryId = this.userData['companyCountryId'];
    params.pincode = this.userData['pincode'];
    params.companyMobileNumber = this.userData['companyMobileNumber'];
    params.companyEmailId = this.userData['customerDetail']['email'];
    params.companyWebsite = this.userData['companyWebsite'];
    params.companyGstNumber = this.userData['companyGstNumber'];
    params.companyPanNumber = this.userData['companyPanNumber'];
    params.bankInformation = this.userData['bankInformation'];
    params.minimumPrice = this.userData['minimumPrice'];
    params.companyGstNumber = this.userData['companyGstNumber'];
    params.companyVatNumber = this.userData['companyVatNumber'];
    params.companyDescription = this.userData['companyDescription'];
    params.ourStory = this.userData['ourStory'];
    params.returnPolicy = this.userData['returnPolicy'];
    params.shippingPolicy = this.userData['shippingPolicy'];
    params.aboutPageVideoType = this.userData['aboutPageVideoType'];
    params.companyDescription = this.userData['companyDescription'];
    params.ourStory = this.userData['ourStory'];
    params.paymentInformation = this.userData['paymentInformation'];
    params.isProfileCompleted = 1;
    params.showShop = this.userData.showShop ? 0 : 1;
    params.tab = 6;
    this.commonSandbox.doEditProfile(params);
    this.userData.showShop = this.userData.showShop ? 0 : 1;
    this.subscriptions.push(this.commonSandbox.editProfileLoaded$.subscribe(data => {
      if (data === true) {
        this.commonSandbox.doGetProfile();
      }
    }));
  }

  // get recent sales list
  getRecentPaymentList() {
    const params: any = {};
    params.limit = 4;
    params.offset = 0;
    this.paymentSandbox.getPaymentList(params);
  }
  onDateSelect(event) {
    this.miniDate = event;
    this.fromDate = event;
    this.dateError = '';
  }

  submit() {
    var newFromDate;
    var newToDate;
    console.log("this.filterByDateTypee", this.filterByDateType);

    if (!this.fromDate && !this.toDate) {
      this.filterByDateType = 0;
      this.toaster.error('Error', 'Please select from,to date first');
      return;
    } else {
      newFromDate = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
      newToDate = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
    }


    const params: any = {};
    params.filterByDateType = this.filterByDateType;

    params.fromDate = newFromDate;
    params.toDate = newToDate;

    console.log("params");
    console.log(params);
    this.dashboardSandbox.getDashboardCounts(params);

  }
  onToDateSelect(event) {
    this.toDate = event;
  }

  setMinValue(d) {

    this.isRequired = false;
    if (!this.fromDate) {
      this.toaster.error('Error', 'Please select from date first');
      return;
    }
    d.toggle();
  }

  filterByShop(event) {
    const params: any = {};
    
  console.log('Selected ID:', this.userData.customerId);
    console.log(event.target.value, 'event.target.value');
    params.vendorId = this.userData.customerId;
    this.dashboardSandbox.loadShop(params);
  }
  filterByDate(event) {
    this.filterByDateType = event.target.value;

    if (this.filterByDateType != 4) {
      this.showCustomDates = false;
      const params: any = {};
      params.filterByDateType = this.filterByDateType;

      params.fromDate = '';
      params.toDate = '';

      this.dashboardSandbox.getDashboardCounts(params);
    } else {
      this.showCustomDates = true;
    }
  }
  // get top selling product list
  getTopSellingProducts() {
    const params: any = {};
    params.duration = this.duration;
    this.dashboardSandbox.getTopSellingProductsList(params);
  }

  // get chart event for orders
  getOrders() {
    this.pieChartData = [];
    this.pieChartLabels = [];
    const params: any = {};
    params.duration = this.orderDuration;
    this.dashboardSandbox.getLanguageList(params);
    this.dashboardSandbox.getLanguageList$.subscribe(data => {
      this.pieChartData = [];
      this.pieChartLabels = [];
      if (data) {
        data.value.forEach(datas => {
          this.pieChartData.push(Number(datas.orderCount));

          this.pieChartLabels.push(datas.name);
          this.pieChartColors[0].backgroundColor.push(datas.colorCode);
        });
      }
    });
  }

  // get product duration event
  getDuration(val) {
    this.duration = Number(val);
    this.getTopSellingProducts();
  }

  getConversionRate(cartAdded, checkout) {
    if (cartAdded > 0) {
      return ((checkout / cartAdded) * 100).toFixed(2);
    } else {
      return 0;
    }

  }

  // get chart duration event
  getChartDuration(val) {
    this.orderDuration = Number(val);
    this.getOrders();
  }




}
